import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ApiErrorDataI } from 'declarations/interfaces/errors';

export type SnackbarSeverityT = 'success' | 'error' | 'warning';

export interface SnackBarPayloadI {
  errorDetails?: ApiErrorDataI | null;
  errorSource?: string;
  snackbarMessage: string;
  snackbarSubMessage?: string;
  snackBarSeverity: SnackbarSeverityT;
}

interface NotificationState {
  isOpen: boolean;
  snackbarMessage: string;
  snackbarSubMessage?: string;
  snackBarSeverity: SnackbarSeverityT;
  errorDetails?: ApiErrorDataI | null;
  errorSource?: string;
}

const initialState: NotificationState = {
  isOpen: false,
  snackbarMessage: '',
  snackBarSeverity: 'success',
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    showSnackbar: (state, action: PayloadAction<SnackBarPayloadI>) => {
      state.isOpen = true;
      state.snackbarMessage = action.payload.snackbarMessage;
      state.snackbarSubMessage = action.payload.snackbarSubMessage;
      state.snackBarSeverity = action.payload.snackBarSeverity;
      state.errorDetails = action.payload.errorDetails;
      state.errorSource = action.payload.errorSource;
    },
    closeSnackbar: state => {
      state.isOpen = false;
    },
  },
});

export const { showSnackbar, closeSnackbar } = notificationsSlice.actions;

export const updateSnackbarNotification = showSnackbar;

export const selectNotification = (state: {
  notifications: NotificationState;
}): NotificationState => state.notifications;

export default notificationsSlice.reducer;
